<template>
    <div class="control">
        <label>
            <input type="checkbox" @click="$emit('onclick')" :checked="vm" />
            <div></div>
        </label>
    </div>
</template>

<script>
/* eslint-disable */
export default {
    name: 'Checkbox',
    props: ['vm']
}
</script>

<style src="../../../assets/css/components/inputs/checkbox.css"></style>